import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

interface DeclarationSearch {
  id?: string
}

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/customs/declaration',
  validateSearch: (s: Record<string, unknown>): DeclarationSearch => ({
    id: typeof s.id === 'string' && s.id.length > 0 ? s.id : undefined,
  }),
}).lazy(() => import('./declaration.lazy').then((d) => d.Route))
